import {Component} from "react";
import "./Warning.css"
import React from 'react';

class Warning extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <div  className={"warning"}>
                <div className={"content"}>
                    <p className={"text"}>
                        Уважаемые пользователи! Поддержка приложения «Социальный навигатор» приостановлена.<br/> Всю необходимую информацию по услугам Вы можете найти на сайте <a className={"link"} href={"https://www.gosuslugi.ru/socialfund"}>Госуслуг</a>
                    </p>
                </div>

            </div>
        );
    }
}

export default Warning;